document.addEventListener("teeinblue-event-component-injected", function () {
  if (sessionStorage.getItem("buttonClicked")) {
    sessionStorage.removeItem("buttonClicked");

    const interval = setInterval(() => {
      const btnCart = document.querySelector(
        ".header-mobile__item.header-mobile__item--cart .cart-icon-bubble"
      );
      if (btnCart) {
        btnCart.click();
        clearInterval(interval);
      }
    }, 1500);
  }

  const button = document.getElementById("teeAtcButton");
  if (button) {
    button.addEventListener("click", function () {
      document.addEventListener(
        "teeinblue-event-after-cart-added",
        async () => {
          sessionStorage.setItem("buttonClicked", "true");
          location.reload();
        }
      );
    });
  }
});
